import { EcoSwitch } from "./eco-switch";

export { EcoSwitch };
